import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { formatImage } from '@ifeng-fe/container_channel/common/client/utils/formatImg';
import Chip from 'Chip';

import NewsImgsTabs from '../../../components/newsImgsTabs';
import ImgNewsWrapper from '../../../components/imgNewsWrapper';
// 新闻图片页
class NewsImgs extends React.PureComponent {
    state = { currentIndex: 0 };
    static propTypes = {
        content: PropTypes.object,
    };

    handleOnChange = index => {
        // console.log(index);
        this.setState({
            currentIndex: index,
        });
    };

    /**
     * 渲染组件
     */
    render() {
        const { currentIndex } = this.state;
        const { content } = this.props;

        // console.log(content);
        const newsPhotos = <ImgNewsWrapper content={content.newsPhotoData} />;
        const milPhotos = <ImgNewsWrapper content={content.milPhotoData} />;
        const sportsPhotos = <ImgNewsWrapper content={content.sportsPhotoData} />;
        const historyPhotos = <ImgNewsWrapper content={content.historyPhotoData} />;

        const changeContent = index => {
            let showDom = '';

            switch (index) {
                case 0:
                    showDom = newsPhotos;
                    break;
                case 1:
                    showDom = milPhotos;
                    break;
                case 2:
                    showDom = sportsPhotos;
                    break;
                case 3:
                    showDom = historyPhotos;
                    break;

                default:
                    break;
            }

            return showDom;
        };

        // console.log('TopSlide=',this.props)
        return (
            <div className={styles.NewsImgs}>
                <Chip
                    id="50110"
                    type="struct"
                    title="新闻图片-文字导航"
                    groupName="凤凰网资讯图片"
                    content={content.newsTabs}>
                    <NewsImgsTabs onChange={this.handleOnChange} />
                </Chip>
                <div>{changeContent(currentIndex)}</div>
            </div>
        );
    }
}
export default errorBoundary(NewsImgs);
